// Shimmer SVG markup imported as raw strings via Vite's ?raw query.
// Returned by getShimmerSvg() based on the document's shape key + sideOfId so
// the guide-box overlay shows a contextual silhouette of the expected document.
// Shape keys are resolved from the catalog's `format` by
// `domain/document-format`, which maps nine formats onto these four assets.
//
// Assets are named for the shape they draw, not for a document, because each
// serves several formats: right-photo ID-1 cards reuse the card silhouette
// flipped (Overlay's `mirrorShimmer`), and A4 and the square-card format
// borrow the booklet one. The booklet has no back page yet, so `side` cannot
// be honoured for that bucket — see getShimmerSvg below.
import passportShimmer from './Passport-Shimmer.svg?raw';
import bookletShimmer from './Booklet_Front_Shimmer.svg?raw';
import idFrontShimmer from './ID_Front_Shimmer.svg?raw';
import idBackShimmer from './ID_Back_Shimmer.svg?raw';

export type ShimmerDocType = 'id-card' | 'passport' | 'greenbook' | null;
export type ShimmerSide = 'Front' | 'Back' | string | undefined;

export function getShimmerSvg(
  docType: ShimmerDocType,
  side: ShimmerSide,
): string {
  if (docType === 'passport') return passportShimmer;
  // `side` is ignored here: there is no booklet back asset to switch to, so
  // the square-card format's back step shows the front silhouette.
  // Outstanding with design.
  if (docType === 'greenbook') return bookletShimmer;
  // Default (including null/unknown) to the ID-card silhouette so the guide
  // is always visible before detection has classified the document.
  return String(side).toLowerCase() === 'back' ? idBackShimmer : idFrontShimmer;
}
